export default [{
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_1.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_2.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_3.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_4.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_5.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_6.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_7.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_8.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_9.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_10.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_11.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_12.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_13.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_14.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_15.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_16.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_17.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_18.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_19.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_20.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_21.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_22.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_23.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_24.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_25.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_26.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_27.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_28.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_29.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_30.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_31.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_32.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_33.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_34.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_35.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_36.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_37.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_38.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_39.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_40.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_41.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_42.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_43.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_44.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_45.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_46.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_47.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_48.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_49.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_50.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_51.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_52.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_53.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_54.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_55.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_56.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_57.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_58.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_59.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_60.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_61.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_62.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_63.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_64.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_65.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_66.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_67.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_68.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_69.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_70.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_71.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_72.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_73.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_74.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_75.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_76.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_77.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_78.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_79.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_80.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_81.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_82.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_83.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_84.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_85.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_86.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_87.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_88.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_89.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_90.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_91.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_92.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_93.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_94.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_95.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_96.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_97.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_98.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_99.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_100.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_101.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_102.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_103.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_104.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_105.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_106.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_107.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_108.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_109.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_110.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_111.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_112.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_113.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_114.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_115.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_116.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_117.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_118.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_119.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_120.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_121.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_122.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_123.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_124.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_125.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_126.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_127.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_128.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_129.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_130.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_131.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_132.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_133.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_134.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_135.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_136.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_137.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_138.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_139.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_140.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_141.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_142.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_143.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_144.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_145.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_146.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_147.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_148.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_149.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_150.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_151.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_152.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_153.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_154.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_155.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_156.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_157.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_158.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_159.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_160.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_161.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_162.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/14jie/14jie_163.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie14.js